import {
    OnInit,
    Component,
    Input,
    Output,
    EventEmitter
 } from '@angular/core';

@Component({
    selector: 'app-inventory-success-buy',
    templateUrl: './success-buy.component.pug',
    styleUrls: ['./success-buy.component.less'],
})
export class SuccessBuyComponent{
    @Input() amount: number;
    @Input() promo: boolean = false;
    @Input() innerHTML: string = null;

    @Output() close: EventEmitter<any> = new EventEmitter();
    
    constructor(
    ) {
    }

    onClose() {
        this.close.emit();
    }
}
